import { BookCornSchema, ContactDataSourceSchema, ContactSchema } from '@eigtech/contacts-types';
import { EventBaseSchema, eventType } from '@eigtech/event-stream-types';
import { z } from 'zod';
const serviceName = 'contacts';
const serviceEventType = (entity, eventName) => eventType(serviceName, entity, eventName);
const bookEventType = (eventName) => serviceEventType('book', eventName);
const claimBookEventType = (eventName) => serviceEventType('claimBook', eventName);
const claimContactEventType = (eventName) => serviceEventType('claimContact', eventName);
const ClaimContactSchema = z.object({
    contact: ContactSchema,
    claimNumber: z.string(),
});
const ServiceEventBaseSchema = EventBaseSchema.extend(z.object({
    type: serviceEventType(),
}).shape);
const BookEventSchema = ServiceEventBaseSchema.extend(z.object({
    type: bookEventType(),
    book: z.unknown(),
    schemaVersion: z.literal(1),
}).shape);
const ClaimContactEventSchema = ServiceEventBaseSchema.extend(z.object({
    type: claimContactEventType(),
    claimContact: ClaimContactSchema,
    metadata: ServiceEventBaseSchema.shape.metadata.and(z.object({
        requestedBy: z.string().optional(),
        dataSource: ContactDataSourceSchema.or(z.string()),
    })),
}).shape);
export const DeprecatedClaimBookMetadataUpdatedEventSchema = BookEventSchema.extend(z.object({
    type: claimBookEventType('metadataUpdated'),
    book: z.object({
        bookId: BookCornSchema,
        primaryContact: ContactSchema.or(z.undefined()),
        carrier: ContactSchema.or(z.undefined()),
        fieldAdjuster: ContactSchema.or(z.undefined()),
        coordinator: ContactSchema.or(z.undefined()),
        policyHolder: ContactSchema.or(z.undefined()),
        hasLegalRep: z.boolean(),
    }),
}).shape);
export const DeprecatedClaimBookLegalRepEventSchema = BookEventSchema.extend(z.object({
    type: claimBookEventType('legalRepSet'),
    book: z.object({
        bookId: BookCornSchema,
        hasLegalRep: z.boolean(),
    }),
}).shape);
export const DeprecatedCarrierSetEventSchema = ClaimContactEventSchema.extend(z.object({
    type: claimContactEventType('carrierSet'),
    claimContact: ClaimContactSchema,
}).shape);
export const DeprecatedPolicyHolderSetEventSchema = ClaimContactEventSchema.extend(z.object({
    type: claimContactEventType('policyHolderSet'),
    claimContact: ClaimContactSchema,
}).shape);
export const DeprecatedPrimaryContactSetEventSchema = ClaimContactEventSchema.extend(z.object({
    type: claimContactEventType('primaryContactSet'),
    claimContact: ClaimContactSchema,
}).shape);
export const DeprecatedPrimaryFieldAdjusterSetEventSchema = ClaimContactEventSchema.extend(z.object({
    type: claimContactEventType('primaryFieldAdjusterSet'),
    claimContact: ClaimContactSchema,
}).shape);
export const DeprecatedPrimaryFieldAdjusterRemovedEventSchema = ClaimContactEventSchema.extend(z.object({
    type: claimContactEventType('primaryFieldAdjusterRemoved'),
    claimContact: ClaimContactSchema.omit({ contact: true }),
}).shape);
export const DeprecatedPrimaryCoordinatorSetEventSchema = ClaimContactEventSchema.extend(z.object({
    type: claimContactEventType('primaryCoordinatorSet'),
    claimContact: ClaimContactSchema,
}).shape);
export const DeprecatedPrimaryCoordinatorRemovedEventSchema = ClaimContactEventSchema.extend(z.object({
    type: claimContactEventType('primaryCoordinatorRemoved'),
    claimContact: ClaimContactSchema.omit({ contact: true }),
}).shape);
export const DeprecatedContactEventSchema = DeprecatedClaimBookMetadataUpdatedEventSchema.or(DeprecatedCarrierSetEventSchema)
    .or(DeprecatedPolicyHolderSetEventSchema)
    .or(DeprecatedPrimaryContactSetEventSchema)
    .or(DeprecatedPrimaryFieldAdjusterSetEventSchema)
    .or(DeprecatedPrimaryFieldAdjusterRemovedEventSchema)
    .or(DeprecatedPrimaryCoordinatorSetEventSchema)
    .or(DeprecatedPrimaryCoordinatorRemovedEventSchema);
